@if (selectIsPongoPluginEnabled() || previewForceVisible) {
  @if (customer) {
    <div
      class="mb-5 lg:rounded lg:rounded-s"
      [ngClass]="{
        'max-w-md mx-auto lg:max-w-4xl': width === 'centered',
        'w-full': width === 'full',
      }"
      [style.backgroundColor]="backgroundColor | contentBuilderColor: defaultBackgroundColor"
    >
      @if (heading) {
        <div class="flex items-center justify-between px-5 pb-2 pt-6">
          <h2
            class="font-accent text-2xl font-bold"
            [style.color]="headingColor | contentBuilderColor: defaultHeadingColor"
          >
            {{ heading | translate }}
          </h2>
        </div>
      }
      @if (subheading) {
        <div
          class="px-5 pb-2 font-base text-sm lg:text-base"
          [style.color]="textColor | contentBuilderColor: defaultTextColor"
        >
          {{ subheading }}
        </div>
      }
      <div
        class="flex flex-row items-center px-5 pb-2 font-base text-sm lg:text-base"
        [style.color]="textColor | contentBuilderColor: defaultTextColor"
      >
        <i
          class="icon icon-coins mt-0.5 pr-1.5"
          [style.color]="iconColor | contentBuilderColor: defaultTextColor"
        ></i>
        @if (!customer.points) {
          <span
            [translate]="'pongo.amount-of-0-point'"
            [translateParams]="{ value: 'world' }"
          ></span>
        }
        @if (customer.points) {
          <span
            [translate]="'pongo.amount-of-points'"
            [translateParams]="{ points: customer.points }"
          ></span>
        }
      </div>
      @if (!assets || assets.length === 0) {
        <div
          class="px-5 pb-6 pt-2 font-base text-sm lg:text-base"
          [style.color]="textColor | contentBuilderColor: defaultTextColor"
        >
          {{ 'pongo.no-assets' | translate }}
        </div>
      }
      <div
        #scrollContainer
        class="w-full overflow-x-auto pt-2 scrollbar-hide"
        [class.pb-6]="!showDesktopScrollbar && assets.length > 0"
        (scroll)="onAssetsScroll()"
      >
        @if (assets.length > 0) {
          <ul
            #assetsRow
            class="flex pl-5 pr-2"
          >
            @for (asset of assets; track asset) {
              <li class="mr-3 w-40 min-w-40 flex-shrink-0 flex-grow-0">
                <ng-container *ngTemplateOutlet="assetCard; context: { asset }"></ng-container>
              </li>
            }
            <li class="w-4 flex-shrink-0"></li>
          </ul>
        }
      </div>
      @if (showDesktopScrollbar) {
        <div
          class="mx-5 mb-6 mt-4 h-1.5 cursor-pointer rounded-full bg-neutral-300"
          (pointerdown)="onScrollbarPointerDown($event)"
          (pointermove)="onScrollbarPointerMove($event)"
          (pointerup)="onScrollbarPointerUp()"
          (pointercancel)="onScrollbarPointerUp()"
        >
          <div
            class="pointer-events-none h-full rounded-full bg-neutral-600"
            [style.width.%]="thumbWidthPercent"
            [style.marginLeft.%]="thumbLeftPercent"
          ></div>
        </div>
      }
    </div>
  }
}

<ng-template
  #assetCard
  let-asset="asset"
>
  <div
    class="pongo-asset-card border flex h-full flex-col justify-between overflow-hidden rounded-lg shadow-S"
    [ngClass]="{
      'opacity-50': !asset.is_usable && !asset.is_buyable,
    }"
    [style.--product-name-color]="productNameColorValue"
    [style.--product-description-color]="productDescriptionColorValue"
    [style.--product-border-color]="productBorderColorValue"
    [style.--product-background-color]="productBackgroundColorValue"
    [style.--hover-bg-color]="hoverBackgroundColorValue"
    [style.--hover-name-color]="hoverNameColorValue"
    [style.--hover-description-color]="hoverDescriptionColorValue"
  >
    @if (asset.picture_url) {
      <div
        class="h-24 max-h-24 w-full shrink-0 overflow-hidden rounded-t-lg"
        [style.backgroundColor]="productImagePlaceholderColorValue"
      >
        <img
          [src]="asset.picture_url"
          alt=""
          class="h-full w-full object-cover"
        />
      </div>
    }
    <div class="flex h-full flex-col justify-between px-3 py-2 pb-3 font-base text-sm">
      <div>
        <p
          class="pongo-asset-card__name mb-2 break-words pt-1 font-accent text-sm font-bold lg:text-base"
        >
          {{ asset.name }}
        </p>
        @if (!asset.is_usable && asset.is_buyable) {
          <p
            class="pongo-asset-card__description font-base text-sm font-normal lg:text-base"
          >
            {{ 'pongo.buy-for-points' | translate: asset }}
          </p>
        }
        @if (!asset.is_usable && !asset.is_buyable) {
          <p
            class="pongo-asset-card__description font-base text-sm font-normal lg:text-base"
          >
            {{ 'pongo.accessible-in-points' | translate: asset }}
          </p>
        }
      </div>

      <div class="mt-6 flex flex-col items-center justify-center">
        @if (isAssetInCart(asset)) {
          <div
            class="pongo-asset-card__description mb-2 flex flex-row items-center justify-center font-base text-sm font-normal leading-snug lg:text-base"
          >
            <i class="icon icon-check-circle mr-2 text-success-600"></i>
            {{ 'pongo.asset-added-to-cart' | translate }}
          </div>
        }
        @if (asset.is_usable && !isAssetInCart(asset)) {
          <app-button-atom
            [label]="'pongo.use-voucher' | translate"
            (click)="useAsset(asset)"
            icon="icon-plus"
            size="XS"
            thickSize="XS"
            type="outlined"
            color="neutral"
          ></app-button-atom>
        }
        @if (asset.is_usable && isAssetInCart(asset)) {
          <app-button-atom
            [label]="'pongo.remove-voucher' | translate"
            (click)="removeAsset(asset)"
            icon="icon-c-remove"
            size="XS"
            thickSize="XS"
            type="outlined"
            color="neutral"
          ></app-button-atom>
        }
        @if (asset.is_buyable) {
          <app-button-atom
            [label]="'pongo.buy-voucher' | translate"
            (click)="buyAsset(asset)"
            [icon]="asset.buyInProcess ? '' : 'icon-plus'"
            [iconUrl]="asset.buyInProcess ? 'assets/images/spinner.svg' : ''"
            size="XS"
            thickSize="XS"
            type="outlined"
            color="neutral"
          ></app-button-atom>
        }
      </div>
    </div>
  </div>
</ng-template>
